// material-ui
import Box from '@mui/material/Box';

// project imports
import LogoHorizontalAlternative from './LogoHorizontalAlternative';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain({ reverse }: { reverse?: boolean }) {
  return (
    <Box sx={{ p: 1.5, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <LogoHorizontalAlternative sx={{ width: '100%', height: '100%' }} />
    </Box>
  );
}
